import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
const routerReplace = Router.prototype.replace

Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error)
}
Router.prototype.replace = function (location) {
  return routerReplace.call(this, location).catch(error => error)
}

Vue.use(Router)

const routes = [
  {
    path: '/',
    meta: {
      title: 'Edmily John'
    },
    component: () => import(/* webpackChunkName: "main" */ '../views/Main.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        meta: {
          title: 'Home'
        },
        component: () =>
          import(/* webpackChunkName: "home" */ '../views/Home/Home.vue').then(c => c.default)
      }
    ]
  },
  // Error 404, must be at the end!
  {
    path: '/:patgMatch(.*)*',
    name: '404',
    meta: {
      title: 'Not found | 404',
      requiresAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "404" */ '../views/404.vue').then(c => c.default)
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0, behavior: 'smooth' }
  }
})

export default router
